var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebstoriesCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 9,
    viewBox: "0 0 42 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4,
    stroke: "#727272"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 4.5,
    r: 4,
    stroke: "#727272"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 4.5,
    r: 4,
    stroke: "#727272"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 4.5,
    r: 4,
    stroke: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebstoriesCircle);
export default __webpack_public_path__ + "static/media/webstories_circle.4e5f2ba134b7e96c567120f3d72053c9.svg";
export { ForwardRef as ReactComponent };